import { hexToRGB } from '@repo-level/core-front';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

export const ScWelcome = styled.div`
  position: relative;

  & > .content {
    position: relative;
    padding: 32px 24px;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    z-index: 2;

    & > .action-btn {
      width: 100%;
      display: flex;
      justify-content: center;

      button {
        max-width: 232px;
      }

      &.de {
        button {
          font-size: 90%;
        }
      }
    }

    & > header {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;

      & > .description {
        font-weight: 800;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
      }
    }

    .benefits {
      width: 100%;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 8px;

      li {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: linear-gradient(
          90deg,
          rgba(184, 29, 122, 0) 0%,
          rgba(184, 29, 122, 0.3) 50.52%,
          rgba(184, 29, 122, 0) 100%
        );
        min-height: 54px;
        padding: 8px;
        border-radius: 12px;

        & > .title {
          font-weight: 700;
          font-size: 12px;
          line-height: 18px;
          text-align: center;
          color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.4)};
        }

        & > .description {
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: ${({ theme }) => theme.whiteColor};
        }
      }
    }
  }

  .character {
    position: absolute;
    right: 0;
    bottom: 0;
    object-fit: contain;
  }

  @media (${device.mobileS}) {
    & > .content {
      padding: 0;
      max-width: 100%;
      gap: 48px;

      & > header {
        gap: 12px;
      }

      .benefits {
        li {
          align-items: flex-start;
          justify-content: center;
          padding: 8px 24px;
          background: linear-gradient(
            90deg,
            rgba(184, 29, 122, 0) 0%,
            rgba(184, 29, 122, 0.3) 12.94%,
            rgba(184, 29, 122, 0) 100%
          );
        }
      }

      & > .action-btn {
        padding: 0 12px;
        button {
          max-width: 100%;
        }
      }
    }

    .character {
      width: auto;
      height: 196px;
    }
  }
`;

export const ScSkipBonusField = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .field-container {
    .label {
      font-size: 12px;
      line-height: 18px;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }
  }

  @media (${device.mobileS}) {
    margin: 48px 0 12px;
    padding: 0 12px;
  }
`;

export const ScOffer = styled.div`
  font-weight: 800;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  letter-spacing: 0.03em;
  color: ${({ theme }) => theme.whiteColor};
`;
